import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as Styled from './PrintDialog.styles';
import { selectors } from '../SideBar/reducer';
import { openPrintDialog } from '../SideBar/actions';
import logo from '../../global/images/logo.png';
import { PRINT_DIALOG } from './constants';
import { getFromLocalStorage } from '../../global/helpers';

const PrintDialog = ({ componentToPrint }) => {
  const printRef = useRef();
  const dispatch = useDispatch();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const now = new Date();
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const date = `${now.getDate()} ${monthNames[now.getMonth()]} ${now.getFullYear()}`;

  const open = useSelector(selectors.printDialogOpen);

  return (
    <Styled.PrintDialogWrapper
      width="calc(100%-100px)"
      onOk={handlePrint}
      onCancel={() => dispatch(openPrintDialog(false))}
      open={open}
      footer={null}
    >
      <Styled.PrintButton onClick={handlePrint}>{PRINT_DIALOG.printButtonText}</Styled.PrintButton>
      <Styled.PrintComponentWrapper ref={printRef} pageStyle={{ width: 877, height: 1240 }}>
        <Styled.PrintComponentHeadingWrapper>
          <img src={logo} alt="" />
          <div>
            <div>{PRINT_DIALOG.resultHeaderText}</div>
            <h1>{`Generated by ${getFromLocalStorage('userName')} on ${date}`}</h1>
          </div>
        </Styled.PrintComponentHeadingWrapper>
        <Styled.ChartsWrapper>{componentToPrint()}</Styled.ChartsWrapper>
        <Styled.FooterWrapper>
          <div className="company-title">{PRINT_DIALOG.companyTitle}</div>
          <div className="source">{PRINT_DIALOG.sourceText}</div>
          <div className="link">{PRINT_DIALOG.website}</div>
        </Styled.FooterWrapper>
      </Styled.PrintComponentWrapper>
    </Styled.PrintDialogWrapper>
  );
};

PrintDialog.propTypes = {
  componentToPrint: PropTypes.func,
};

PrintDialog.defaultProps = {
  componentToPrint: null,
};

export default PrintDialog;
